import EntityType from '@/shared/enums/EntityType';
import {
  PropertyEntity,
  PropertyValueEntity,
  SkillEntity,
  SkillLevelEntity,
  TagEntity,
  TagCategoryEntity,
} from '@enums/MappedEntityTypes';

export default function combinedEntityType(type, subType) {
  switch (subType) {
    case EntityType.PROPERTY:
      return PropertyEntity[type];
    case EntityType.PROPERTY_VALUE:
      return PropertyValueEntity[type];
    case EntityType.ROLE_TYPE:
    case EntityType.ACTIVITY_TYPE:
      return subType;
    case EntityType.SKILL:
      return SkillEntity[type];
    case EntityType.SKILL_LEVEL:
      return SkillLevelEntity[type];
    case EntityType.TAG:
      return TagEntity[type];
    case EntityType.TAG_CATEGORY:
      return TagCategoryEntity[type];
    default:
      return type;
  }
}
